import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IDonorProfileRecords,  } from '@nkr/models/index';

export interface IDonorProfileRecordsResponse {
    data: {
        success: boolean;
        results: IDonorProfileRecords;
    }
}

export const ActionCreators = {
    getProfileRecordsData: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileRecordsResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/records`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

}